import { G, Path, Svg } from '@react-pdf/renderer'

interface CopyrightIconProps {
  size?: number
}

const CopyRightIcon = ({ size }: CopyrightIconProps) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 64 64'
      aria-hidden='true'
      preserveAspectRatio='xMidYMid meet'
    >
      <G fill='#596B7B'>
        <Path d='M32 2C18.2 2 7 13.2 7 27s11.2 25 25 25s25-11.2 25-25S45.8 2 32 2m0 45c-11 0-20-9-20-20S21 7 32 7s20 9 20 20s-9 20-20 20'></Path>

        <Path d='M25.4 19.3c.9-1 2-1.8 3.3-2.3c1.3-.6 2.6-.9 4-.9c1.7 0 3.4.4 4.8 1.3c1.4.8 2.7 2 3.6 3.3l3.6-2.7c-1.4-1.8-3.1-3.4-5.1-4.4c-2.1-1.1-4.3-1.6-6.8-1.6c-2 0-4 .4-5.8 1.2c-1.8.8-3.4 1.9-4.7 3.2c-1.3 1.4-2.4 2.9-3.2 4.8c-.8 1.8-1.2 3.8-1.2 5.8c0 2.1.4 4 1.2 5.8c.8 1.8 1.8 3.4 3.2 4.8c1.3 1.4 2.9 2.4 4.7 3.2c1.8.8 3.7 1.2 5.8 1.2c2.5 0 4.8-.5 6.8-1.6s3.8-2.6 5.1-4.4l-3.6-2.7c-.9 1.4-2.1 2.5-3.6 3.3c-1.5.8-3.1 1.2-4.8 1.2c-1.4 0-2.7-.3-4-.9c-1.2-.6-2.3-1.4-3.3-2.3c-.9-1-1.7-2.1-2.2-3.4s-.8-2.7-.8-4.2s.3-2.9.8-4.2s1.3-2.5 2.2-3.5'></Path>
      </G>
    </Svg>
  )
}

export default CopyRightIcon
